import { getBase64 } from "../../../utils/base64";
import { uploadFile } from "../../Shared/upload-file";

export const uploadAppointmentAttachment = async (file) => {
  try {
    const base64 = await getBase64(file);
    const { hasSuccess, data } = await uploadFile({
      file: base64,
      type: file.type,
      name: file.name,
      source: "appointments"
    });
    return {
      hasSuccess,
      data: hasSuccess
        ? { Location: data.Location, Key: data.Key, name: file.name, type: file.type }
        : data
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message
    };
  }
};
